import { useEffect, useRef, useState } from 'react';

import { Box, Text, Tooltip } from '@chakra-ui/react';

export default function GroupCellRenderer({ data, value }) {
    const items = data?.items ?? [];
    const [isOpen, setIsOpen] = useState(false);
    const triggerRef = useRef(null);

    useEffect(() => {
        if (!isOpen) return undefined;

        const handleMouseDown = (event) => {
            const target = event.target;
            const tooltip =
                target instanceof Element
                    ? target.closest('[role="tooltip"]')
                    : null;

            if (triggerRef.current?.contains(target) || tooltip) {
                return;
            }

            setIsOpen(false);
        };

        document.addEventListener('mousedown', handleMouseDown);

        return () => {
            document.removeEventListener('mousedown', handleMouseDown);
        };
    }, [isOpen]);

    return (
        <Tooltip
            isOpen={isOpen}
            hasArrow
            placement="right"
            maxW="none"
            pointerEvents="auto"
            label={
                <Box
                    maxH="260px"
                    minW="200px"
                    overflowY="auto"
                    pr={1}
                    sx={{
                        scrollbarWidth: 'none',
                        msOverflowStyle: 'none',
                        '&::-webkit-scrollbar': {
                            display: 'none',
                        },
                    }}>
                    <Text fontSize="xs" fontWeight="semibold" mb={1}>
                        Blocks in group
                    </Text>
                    {items.length > 0 ? (
                        items.map((item, idx) => (
                            <Box
                                key={idx}
                                display="grid"
                                gridTemplateColumns="1fr auto"
                                columnGap={6}
                                fontFamily="mono"
                                fontSize="xs">
                                <Text as="span" whiteSpace="nowrap">
                                    {item.number}
                                </Text>
                                <Text
                                    as="span"
                                    color="whiteAlpha.700"
                                    whiteSpace="nowrap">
                                    size {item.blockSize}
                                </Text>
                            </Box>
                        ))
                    ) : (
                        <Text fontSize="xs">No block details available.</Text>
                    )}
                </Box>
            }>
            <Text
                ref={triggerRef}
                as="span"
                cursor="help"
                fontSize="sm"
                onClick={(event) => {
                    event.stopPropagation();
                    setIsOpen((current) => !current);
                }}
                textUnderlineOffset="3px">
                {value}
            </Text>
        </Tooltip>
    );
}
